import {branchPath} from '@github-ui/paths'
import {BranchName} from '@primer/react'
import styles from './BranchLink.module.css'
import {clsx} from 'clsx'

export function BranchLink({
  refName,
  repository,
  linkInTextBlock,
}: {
  refName: string
  repository: {ownerLogin: string; name: string} | null
  linkInTextBlock: boolean
}) {
  if (!repository || !repository.name) {
    return (
      <BranchName as="span" className={clsx('d-inline wb-break-all', styles.branchName)}>
        {refName}
      </BranchName>
    )
  }

  const branchUrl = branchPath({
    owner: repository.ownerLogin,
    repo: repository.name,
    branch: refName,
  })

  return (
    <BranchName
      href={branchUrl}
      className={clsx('d-inline wb-break-all', styles.branchName, linkInTextBlock && 'Link--inTextBlock')}
    >
      {refName}
    </BranchName>
  )
}
